<div id="articleList" class="vertical-layout primary-axis-centered secondary-axis-centered">

    <news-article class="list-entry" *ngFor="let newsArticle of newsArticles" [newsArticle]="newsArticle"></news-article>

</div>
